<input
  type="text"
  [title]="'dossierSearch.label' | translate"
  [value]="term()"
  (input)="onSearchInput($event)"
  [placeholder]="'dossierSearch.placeholder' | translate"
  class="w-full rounded-md border border-gray-300 bg-white p-2 text-sm text-cmi-gray" />

@if (loading()) {
  <div class="mt-4 flex justify-center">
    <cmi-loading-spinner />
  </div>
} @else if (results.failed()) {
  <cmi-notification
    class="mt-4 block"
    mode="error"
    [message]="'dossierSearch.error' | translate"
    [actionLabel]="'dossierSearch.retry' | translate"
    (actionClick)="onReload()" />
} @else if (results.dossiers(); as dossiers) {
  @if (dossiers.length) {
    <ng-container *ngTemplateOutlet="dossierList; context: { $implicit: dossiers }" />
  } @else {
    <div class="mt-3 rounded-lg border border-dashed border-gray-300 py-8 text-center">
      <p class="mb-1 text-sm font-medium text-cmi-gray">
        {{ 'dossierSearch.noResults' | translate: { searchTerm: searchedTerm() } }}
      </p>
      <p class="text-xs text-cmi-gray-mid">{{ 'dossierSearch.noResultsHint' | translate }}</p>
    </div>
  }
} @else if (proposals().length) {
  <p class="mt-3 text-xs font-medium tracking-wide text-cmi-gray-mid uppercase">
    {{ 'dossierSearch.proposals' | translate }}
  </p>
  <ng-container *ngTemplateOutlet="dossierList; context: { $implicit: proposals() }" />
} @else if (searchTermTooShort()) {
  <p class="mt-2 text-xs text-cmi-gray-mid">
    {{ 'dossierSearch.minLengthHint' | translate }}
  </p>
}

<ng-template #dossierList let-dossiers>
  <ul class="mt-3 flex flex-col gap-1">
    @for (dossier of dossiers; track dossier.guid) {
      <li>
        <button
          type="button"
          (click)="dossierSelect.emit(dossier)"
          [attr.aria-pressed]="isSelected(dossier)"
          class="w-full cursor-pointer rounded-lg px-3 py-2 text-left"
          [ngClass]="isSelected(dossier) ? 'bg-main-light' : 'bg-white hover:bg-cmi-gray-light'">
          <span
            class="block truncate text-sm"
            [ngClass]="isSelected(dossier) ? 'font-medium text-main' : 'text-cmi-gray'">
            {{ dossier.titel }}
          </span>
          <span class="block text-xs text-cmi-gray-mid">{{ dossier.laufnummer }}</span>
        </button>
      </li>
    }
  </ul>
</ng-template>
